<script setup>
import { ref, defineExpose } from 'vue'
import Poleroid from '@components/global/accents/frames/Poleroid.vue'
import Tag from '@components/global/Tag.vue'
import { useGlobalStore } from '@stores/global.js'

const global = useGlobalStore()
const award = global.modal.payload

const setup = ref({
	type: 'dark',
	wide: true,
})

defineExpose({ setup })
</script>

<template>
	<div class="h-full overflow-y-scroll pt-24">
		<div class="flex flex-col gap-8 px-10">
			<div class="flex flex-col items-start gap-5">
				<img class="h-52 object-contain brightness-150 grayscale transition-all duration-300 group-hover:brightness-100 group-hover:grayscale-0" src="https://cdn.papercrowns.com/website/images/elements/etches/banner-gold.png" alt="" />
				<h4>{{ award.name }}</h4>
				<div class="flex gap-1.5">
					<Tag v-for="year in award.years">{{ year }}</Tag>
				</div>
			</div>
			<div class="flex flex-col gap-5">
				<div class="flex items-center gap-3" v-for="highlight in award.highlights">
					<img class="h-10" src="https://cdn.papercrowns.com/website/images/elements/etches/homestead.svg" alt="Homestead Icon" />
					<div class="text-crowns-off-white">{{ highlight }}</div>
				</div>
			</div>
			<div>
				<p>{{ award.description }}</p>
			</div>
		</div>

		<div class="flex flex-col items-end overflow-x-hidden pt-5">
			<Poleroid class="mt-10 rotate-[15deg]" :src="award.gallery_images[1]" alt="Esports Awards" v-if="award.gallery_images?.[1]" />
			<Poleroid class="-mt-20 mb-10 mr-52 rotate-[-10deg]" :src="award.gallery_images[0]" alt="Esports Awards" v-if="award.gallery_images?.[0]" />
		</div>
	</div>
</template>
